import { BaseElement } from './base-element';
import { ElementType } from './element-type';

export class Container extends BaseElement {
  constructor() {
    super();
    this.elementType = ElementType.container;
  }
}
